export default ({ strapi }) => {
	// bootstrap phase
};
